<template>
  <div id="app">
    <div id="nav">
    </div>
    <!-- <router-view :key="$router.path"></router-view> -->
    <router-view/>
  </div>
</template>
<script>
export default {
  name:'App',
  mounted(){
	
  },
  components: {
    //Home
    // login
  }
}
</script>>
<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
/* } */
/* #nav a {
  font-weight: bold;
  color: #2c3e50;
} */
select{
  border-radius: 5px;
  /* box-shadow: #fff 1px 1px 0px 0px; */
  cursor: pointer;
}
i{
  user-select: none;
}
body{
  height: 100%;
  /* user-select: none; */
}
</style>
